var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: {
            height: "100%",
            padding: "0 5px",
            display: "flex",
            "flex-direction": "row"
          }
        },
        [
          _c("cargo-ag-grid", {
            class: _vm.isPreview || _vm.isEdit ? "not-click" : "",
            staticStyle: { flex: "0 0 auto", width: "200px", margin: "5px 0" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "row-data": _vm.rowData,
              "show-side-bar": false
            }
          }),
          _c("div", {
            staticStyle: {
              flex: "0 0 auto",
              width: "2px",
              margin: "0 5px",
              background: "#DCDFE6"
            }
          }),
          _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: { "flex-grow": "1", height: "auto", margin: "5px 0" }
            },
            [
              _c("div", { staticClass: "operations" }, [
                _c("div", { staticClass: "triggers" }, [
                  !!_vm.validateRow
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "5px",
                            "margin-bottom": "5px"
                          }
                        },
                        [
                          _vm.isPreview
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    key: "back",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.isPreview = false
                                        _vm.previewConfig = null
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Back"))
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          !_vm.isPreview
                            ? [
                                _vm.readonly
                                  ? [
                                      _c(
                                        "el-button",
                                        {
                                          key: "edit",
                                          attrs: { type: "primary" },
                                          on: { click: _vm.onEdit }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Message.Edit")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          key: "readPreview",
                                          attrs: { type: "primary" },
                                          on: { click: _vm.onPreview }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Preview")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "el-button",
                                        {
                                          key: "save",
                                          attrs: { type: "success" },
                                          on: { click: _vm.onSave }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Save")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          key: "cancel",
                                          attrs: { type: "success" },
                                          on: { click: _vm.onCancel }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Message.Cancel"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          key: "editPreview",
                                          attrs: { type: "primary" },
                                          on: { click: _vm.onPreview }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Preview")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          key: "reset",
                                          attrs: { type: "warning" },
                                          on: { click: _vm.onReset }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Message.Reset"))
                                          )
                                        ]
                                      )
                                    ],
                                _c(
                                  "span",
                                  {
                                    key: "opOffice",
                                    staticStyle: { margin: "0px 8px" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_BranchCompany")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: _vm.isEdit,
                                      filterable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.loadData()
                                      }
                                    },
                                    model: {
                                      value: _vm.branchId,
                                      callback: function($$v) {
                                        _vm.branchId = $$v
                                      },
                                      expression: "branchId"
                                    }
                                  },
                                  _vm._l(_vm.officeList, function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: _vm.getOfficeLabel(item),
                                        value: item.officeId
                                      }
                                    })
                                  }),
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ])
              ]),
              _vm.validateRow
                ? [
                    _vm.validateRow.pageType === _vm.SEA_BOOKING_BASIC
                      ? _c("sea-booking-basic", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": [],
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.SEA_BOOKING_VESSEL
                      ? _c("sea-booking-vessel", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.SEA_BOOKING_SPECIAL_GOODS
                      ? _c("sea-booking-special-goods", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.SEA_BOOKING_CUSTOMS
                      ? _c("customs-info", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.SEA_BOOKING_TRUCKING
                      ? _c("sea-booking-trucking", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType ===
                    _vm.SEA_BOOKING_DISCHARGING_TRUCKING
                      ? _c("sea-booking-discharging-trucking", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.SEA_BOOKING_CONTAINER_INFO
                      ? _c("sea-booking-container", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.INTEGRATED_IC_BOOKING
                      ? _c("ic-booking-basic", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.INTEGRATED_CL_BOOKING
                      ? _c("cl-booking-basic", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.INTEGRATED_TT_BOOKING
                      ? _c("tt-booking-basic", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType ===
                    _vm.SEA_BOOKING_DOMESTIC_BILLING
                      ? _c("sea-booking-internal-bill", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.validateRow.pageType === _vm.SEA_BOOKING_OVERSEA_BILL
                      ? _c("sea-booking-oversea-bill", {
                          attrs: {
                            "branch-id": _vm.branchId,
                            "is-edit": _vm.isEdit,
                            blocks: _vm.blocks,
                            "added-elements": _vm.addedElementsForEdit,
                            "is-preview": _vm.isPreview,
                            "preview-config": _vm.previewConfig
                          }
                        })
                      : _vm._e(),
                    _vm.gridTabPageTypes.includes(_vm.validateRow.pageType)
                      ? _c(
                          "grid-tab",
                          {
                            attrs: {
                              "branch-id": _vm.branchId,
                              "is-edit": _vm.isEdit,
                              blocks: _vm.blocks,
                              "added-elements": _vm.addedElementsForEdit,
                              "is-preview": _vm.isPreview,
                              "preview-config": _vm.previewConfig
                            }
                          },
                          [
                            _c("se-tab-lcl-container", {
                              attrs: {
                                slot: "preview",
                                context: _vm.seBookingWorkspaceContext,
                                action: "look",
                                "preview-config": _vm.previewConfig,
                                "enable-ui-custom": true
                              },
                              slot: "preview"
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }